import { portfolioTemplates } from '../utils/serverRoutes';
import makeRequest from '../utils/makeRequest';
import { transformResponseCollection } from '../utils/helpers';
import { localizePortfolioTemplates } from '../utils/factories/portfolioTemplate';

const portfolioTemplate = {
  state: {
    collection: [],
    loaded: false,
  },
  reducers: {
    fetchPortfolioTemplatesReducer(state, { collection }) {
      return { ...state, collection, loaded: true };
    },
  },
  effects: (dispatch) => ({
    fetchPortfolioTemplates() {
      makeRequest({
        dispatch,
        url: portfolioTemplates(),
        success: (response) => {
          const templates = transformResponseCollection(response.data.data);
          const localizedTemplates = localizePortfolioTemplates(templates);

          dispatch.portfolioTemplate.fetchPortfolioTemplatesReducer({
            collection: localizedTemplates,
          });
        },
      });
    },
  }),
};

export default portfolioTemplate;
